import Input from './Input';
import TextArea from './TextArea';
import Password from './Password';
import Number from './Number';
import PhoneNumber from './PhoneNumber';
// Assign the sub-components to the Input component
const EnhancedInput = Input;
EnhancedInput.TextArea = TextArea;
EnhancedInput.Password = Password;
EnhancedInput.Number = Number;
EnhancedInput.PhoneNumber = PhoneNumber;
export default EnhancedInput;
//# sourceMappingURL=index.js.map